import { render, staticRenderFns } from "./SuccessPage.vue?vue&type=template&id=3946a72c&scoped=true&"
import script from "./SuccessPage.vue?vue&type=script&lang=ts&"
export * from "./SuccessPage.vue?vue&type=script&lang=ts&"
import style0 from "./SuccessPage.vue?vue&type=style&index=0&id=3946a72c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3946a72c",
  null
  
)

export default component.exports